import {load} from '@shopify/theme-sections'

import '../../styles/templates/collection.scss'
import '../../styles/sections/template-collection-algolia.scss'
import '../../styles/sections/general-equipment-footer.scss'

import '../sections/template-collection-algolia'
import '../sections/section-table-info'
import '../sections/section-collection-grid-info'
import '../sections/section-enquire-form-v2'
import '../sections/section-three-card-blogs'
import '../sections/index-image-content'
import '../sections/section-six-tiles'
import '../sections/section-steps'
import '../sections/section-4-col-tiles'
import '../sections/section-heading-text'
import '../sections/section-center-text'
import '../sections/section-accordion-two-columns-v2'
import '../sections/custom-images'
import '../sections/section-custom-collection-list'
import '../sections/section-img-text'
import '../sections/index-hero-slider'
import '../sections/section-business-location'
import '../sections/section-flexible-video'

load([
    `template-collection-algolia`,
    `section-2-price-card`,
    `section-enquire-form-v2`,
    `section-three-card-blogs`,
    `index-image-content`,
    `section-six-tiles`,
    `section-collection-grid-info`,
    `section-table-info`,
    `section-steps`,
    `section-4-col-tiles`,
    `section-accordion-two-columns-v2`,
    `custom-images`,
    `section-custom-collection-list`,
    `index-hero-slider`,
    `business-location-section`,
    `section-flexible-video`,
])
